import * as React from "react";
import { Link } from "gatsby";

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer has-background-black has-text-white-ter">
        <div className="content has-text-centered">
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </footer>
    );
  }
};

export default Footer;
